import { render, staticRenderFns } from "./clienteTransportes.vue?vue&type=template&id=0de2ccb0&"
import script from "./clienteTransportes.vue?vue&type=script&lang=js&"
export * from "./clienteTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports